import ApiError from '../entities/ApiError'

const INTERNAL_SERVER_ERROR_STATUS = 500

const isOrderHandoverError = (error: ApiError): boolean => error.status === INTERNAL_SERVER_ERROR_STATUS

export default isOrderHandoverError
